// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingSpecialInstructionsPanel_root__Ed1lh","form":"EditListingSpecialInstructionsPanel_form__1n5Mu","title":"EditListingSpecialInstructionsPanel_title__2Wcf0"};